(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
     
document.addEventListener('DOMContentLoaded', function () {
  const mediaQuery = window.matchMedia('(min-width: 990px)');
  const wrapper = document.querySelector('.header-wrapper');
  const menu = wrapper ? wrapper.querySelector('.header__inline-menu') : null;
  const underline = wrapper ? wrapper.querySelector('.farini-nav-underline') : null;

  if (!wrapper || !menu || !underline) return;

  let activeTarget = null;
  let closeTimer = null;

  function closeAllMenus(exceptDetails) {
    menu.querySelectorAll('details[open]').forEach(function (details) {
      if (details !== exceptDetails) {
        details.removeAttribute('open');
      }
    });
  }

  function showUnderline(target) {
    if (!mediaQuery.matches || !target) return;

    activeTarget = target;

    const wrapperRect = wrapper.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const left = targetRect.left - wrapperRect.left;

    underline.style.width = targetRect.width + 'px';
    underline.style.transform = 'translate3d(' + left + 'px, 0, 0)';
    underline.classList.add('is-visible');
  }

  function hideUnderline() {
    activeTarget = null;
    underline.classList.remove('is-visible');
    underline.style.width = '0px';
  }

  function refreshUnderline() {
    if (activeTarget && mediaQuery.matches) {
      showUnderline(activeTarget);
    } else {
      hideUnderline();
    }
  }

  function cancelClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleClose(details) {
    cancelClose();

    closeTimer = setTimeout(function () {
      if (details) {
        details.removeAttribute('open');
      }

      hideUnderline();
      closeTimer = null;
    }, 180);
  }

  const topItems = menu.querySelectorAll('.list-menu--inline > li');

  topItems.forEach(function (item) {
    const target = item.querySelector('.header__menu-item');
    const details = item.querySelector('details');
    const megaContent = details ? details.querySelector('.mega-menu__content') : null;

    if (!target) return;

    function openItem() {
      if (!mediaQuery.matches) return;

      cancelClose();
      closeAllMenus(details || null);

      if (details) {
        details.setAttribute('open', '');
      }

      showUnderline(target);
    }

    function closeItem() {
      if (!mediaQuery.matches) return;
      scheduleClose(details || null);
    }

    item.addEventListener('mouseenter', openItem);
    item.addEventListener('mouseleave', closeItem);

    if (megaContent) {
      megaContent.addEventListener('mouseenter', openItem);
      megaContent.addEventListener('mouseleave', closeItem);
    }

    target.addEventListener('focus', openItem);

    if (details) {
      const summary = details.querySelector('summary');

      if (summary) {
        summary.addEventListener('click', function (event) {
          if (mediaQuery.matches) {
            event.preventDefault();
          }
        });
      }
    }
  });

  window.addEventListener('resize', refreshUnderline);
  window.addEventListener('scroll', refreshUnderline, { passive: true });

  mediaQuery.addEventListener('change', function () {
    closeAllMenus(null);
    hideUnderline();
  });
});

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
